import { useContext } from 'react';
import { Link, useLocation } from 'react-router-dom';
import CookieConsent from 'react-cookie-consent';
import { GeneralContext } from '../../context/generalContext';

import '../../styles/App.scss';
import './CookieConsentBar.scss';
import cookieIcon from '../../images/cookie-icon.svg';
import ReserveBtn from '../SideButtons/ReserveBtn';
import DeliveryBtn from '../SideButtons/DeliveryBtn';
import { checkDomain } from '../../functions/checkDomain/checkDomain';

function CookieConsentBar() {
  const { windowWidth, activeMenuItem } = useContext(GeneralContext);

  // скрываем на странице скачивания приложения
  const { pathname } = useLocation();
  if (pathname === '/club-app' || pathname === '/en/club-app') return null;

  return (
    <CookieConsent
      location='bottom'
      containerClasses='cookie-consent'
      contentClasses='cookie-consent-content'
      buttonWrapperClasses='cookie-consent-btns'
      buttonText='Разрешить куки'
      declineButtonText='Отказаться'
      cookieName='acceptCookie'
      enableDeclineButton
      flipButtons
      disableStyles
      expires={150} // кол-во дней хранения куки
      extraCookieOptions={{ domain: checkDomain() }}
    >
      <div className='cookie-consent-icon'>
        <img src={cookieIcon} alt='' />
      </div>
      <div className='cookie-consent-desc'>
        <div className='cookie-consent-title'>Мы используем файлы cookie</div>
        <div className='cookie-consent-text'>
          Это нужно, чтобы улучшить ваше пребывание на нашем сайте. Используя наш сайт, вы даете согласие на
          использование файлов cookie.
          <Link className='cookie-consent-link' to='/privacy-policy'>
            &nbsp;Узнать подробнее
          </Link>
        </div>
      </div>
      {windowWidth > 767 && (
        <div className='footer-fixed-btns-abovecookie'>
          {activeMenuItem !== 3 && <ReserveBtn isMobile={false} />}
          <DeliveryBtn isMobile={false} />
        </div>
      )}
    </CookieConsent>
  );
}

export default CookieConsentBar;
